import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const ThinkleticsPointsList = () => {
    const [points, setPoints] = useState([]);

    useEffect(() => {
        const fetchPoints = async () => {
            try {
                const response = await axios.get('/api/thinkleticspoints');
                setPoints(response.data);
            } catch (error) {
                console.error('Error fetching points', error);
            }
        };

        fetchPoints();
    }, []);

    return (
        <div>
            <h1>Active Thinkletics Points</h1>
            <ul>
                {points.map(point => (
                    <li key={point._id}>
                        <Link to={`/thinkleticspoints/${point._id}`}>
                            <h2>{point.eventTitle}</h2>
                        </Link>
                        <p>Event Code: {point.eventCode}</p>
                        <p>Event Step: {point.eventStep}</p>
                        {/* Add more fields as needed */}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ThinkleticsPointsList;
